import { computed } from "vue";
import { type RouteLocationRaw, useRoute, useRouter } from "vue-router";

interface LoginRoute {
  /** Route or href, depending on type */
  route: string | RouteLocationRaw;
  /** href of the resolved route */
  href: string;
  /** router-link if current page is a SPA page, otherwise a */
  type: "router-link" | "a";
}

export function useLoginRoute() {
  const route = useRoute();
  const router = useRouter();

  const routeType = computed<LoginRoute["type"]>(() => {
    const isSpaRoute = route.matched.length > 0;

    return isSpaRoute ? "router-link" : "a";
  });

  const loginRoute = computed<LoginRoute>(() => {
    const query = {
      back: route.fullPath
    };

    if (route.matched.length === 0) {
      // Not all pages are in vue-router yet, so we can't always use the router to get the current route
      const path = window.location.pathname.replace(/^\/(da|en|de)\//, "/");
      const queryString = window.location.search;

      query.back = `${path}${queryString}`;
    }

    if (query.back.startsWith("/error/")) {
      query.back = router.resolve({ name: "home" }).href;
    }

    const resolvedRoute = router.resolve({ name: "login", query });

    return {
      route: routeType.value === "a" ? resolvedRoute.href : resolvedRoute,
      href: resolvedRoute.href,
      type: routeType.value
    };
  });

  return loginRoute;
}
